import {Component, OnInit} from '@angular/core';
import {AbstractControl, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {AuthService} from '../../services/auth.service';
import {TokenStorageService} from '../../services/storage/token-storage.service';
import {UserService} from '../../services/user.service';
import Validation from '../../utils/Validation';

@Component({
    selector: 'app-change-password-page',
    templateUrl: './change-password-page.component.html',
    styleUrls: ['./change-password-page.component.css'],
    standalone: false
})
export class ChangePasswordPageComponent implements OnInit {
  form: FormGroup = new FormGroup({});
  submitted: boolean = false;
  loading: boolean = false;
  isFirstTimeChange: boolean = false;
  user: any;
  showPasswordStrength: boolean = false;
  newPasswordType: boolean = false;
  confirmPasswordType: boolean = false;

  constructor(private formBuilder: FormBuilder,
              private toastr: ToastrService,
              private userService: UserService,
              private router: Router,
              private route: ActivatedRoute,
              private tokenStorage: TokenStorageService,
              private authService: AuthService) {
  }

  ngOnInit() {
    this.isFirstTimeChange = this.router.url.includes('/login/change-password');
    console.log(this.isFirstTimeChange)
    this.initializeForm();
    this.user = this.tokenStorage.getUser();
  }

  initializeForm(): void {
    this.form = this.formBuilder.group(
      {
        currentPassword: [
          '',
          [Validators.required]
        ],
        newPassword: [
          '',
          [
            Validators.required,
            Validators.minLength(8)
          ]
        ],
        confirmPassword: [
          '',
          [
            Validators.required,
          ]
        ]
      },
      {
        validators: [Validation.match('newPassword', 'confirmPassword')]
      }
    );
  }

  onClickSubmit() {
    this.submitted = true;
    if (this.form.invalid) {
      this.toastr.error('Please enter Strong passwords', 'Change password failed');
      return;
    }

    const {currentPassword, newPassword} = this.form.value;

    if (currentPassword == newPassword) {
      this.toastr.error('Existing password and new password should not be same!');
      return;
    }

    this.loading = true;
    this.userService.changeBrokerPassword(this.user.username, currentPassword, newPassword, this.isFirstTimeChange).subscribe(
      {
        next: (data) => {
          this.loading = false;
          if (data.status == 'SUCCESS') {
            if (this.isFirstTimeChange) {
              const initialLoginFlag = 0;
              let userData = this.tokenStorage.getUser();
              userData = {...userData, initialLoginFlag}
              this.tokenStorage.saveUser(userData);
              // this.authService.changeLoginStatus(true);
              this.toastr.success('Logged in as a ' + this.user.role + ' user', 'Login success');
              this.router.navigate(['/']);
            } else {
              this.toastr.success('Password changed successfully', 'Success');
              this.logout();
            }
          } else {
            this.toastr.error(data.reason, 'Change password failed');
          }
        },
        error: (err) => {
          this.loading = false;
          this.toastr.error(err.error.message, 'Change password failed');
        }
      }
    );
  }

  passwordChanged(passwordStrength: any) {
    if (passwordStrength > 90) {
      setTimeout(() => {
        this.form.controls["newPassword"].setErrors(null);
      }, 0);
    } else {
      setTimeout(() => {
        this.form.controls["newPassword"].setErrors({'invalid': true});
      }, 0);
    }
  }

  onNewPasswordFocus() {
    this.showPasswordStrength = true;
  }

  onNewPasswordBlur() {
    this.showPasswordStrength = false;
  }

  toggleNewPasswordTextType() {
    this.newPasswordType = !this.newPasswordType;
  }

  toggleConPasswordTextType() {
    this.confirmPasswordType = !this.confirmPasswordType;
  }

  get formControl(): { [key: string]: AbstractControl } {
    return this.form.controls;
  }

  logout(): void {
    this.authService.changeLoginStatus(false);
    this.tokenStorage.signOut();
    window.location.reload();
  }

}
